<template>
  <div class="home col-md-11">
    <section class="home__hero">
      <div class="home__hero-text">
        <p class="home__eyebrow">{{greeting}}</p>
        <h1>{{firstName}}, bem-vindo ao SCL</h1>
        <p>Sistema de Controle Leiteiro da Associação dos Criadores de Gado Jersey do Brasil.</p>
      </div>
      <span class="home__hero-logo"><img src="@/assets/logo-jersey.jpeg" alt="Jersey"></span>
    </section>

    <section v-for="nav in sections" :key="nav.title" class="home__section">
      <h2>{{nav.title}}</h2>
      <div class="home__grid">
        <router-link
          v-for="item in nav.items"
          :key="item.name"
          :to="item.to"
          class="home__card"
        >
          <span class="home__icon"><i :class="`mdi ${item.icon}`"></i></span>
          <span class="home__label">{{item.name}}</span>
          <i class="mdi mdi-arrow-right home__arrow"></i>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { visibleNav } from "@/router/navigation";

// Atalhos para as mesmas telas do menu (mesmas regras por perfil do cabeçalho).
export default {
  name:"Home",
  computed: {
    ...mapState("login", ["user"]),
    firstName() {
      const name = ((this.user && this.user.attributes && this.user.attributes.name) || "").trim();
      return name ? name.split(" ")[0] : "Olá";
    },
    greeting() {
      const hour = new Date().getHours();
      return hour < 12 ? "Bom dia" : hour < 18 ? "Boa tarde" : "Boa noite";
    },
    sections() {
      const nav = visibleNav(this.user);
      const groups = nav.filter(e => e.subRoutes).map(e => ({
        title: e.title,
        items: e.subRoutes.map(sub => ({name: sub.name, icon: sub.icon, to: {name: sub.path}}))
      }));
      const links = nav.filter(e => e.path).map(e => ({name: e.title, icon: e.icon, to: e.path}));
      return links.length ? [...groups, {title: "Consultas", items: links}] : groups;
    }
  }
}
</script>

<style scoped>
  .home {
    padding: 4px 0 12px !important;
  }
  .home__hero {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    padding: 34px 40px;
    border-radius: 16px;
    color: white;
    background: linear-gradient(120deg, #b98300 0%, #a87600 55%, #8f6400 100%);
    box-shadow: 0 10px 30px rgba(185, 131, 0, .25);
    animation: rise .45s ease-out;
  }
  .home__hero::after {
    content: "";
    position: absolute;
    width: 420px;
    height: 420px;
    right: -120px;
    top: -200px;
    border-radius: 50%;
    background: rgba(255, 255, 255, .09);
  }
  .home__hero-text {
    position: relative;
    z-index: 1;
  }
  .home__eyebrow {
    margin: 0 0 4px;
    font-size: .85rem;
    font-weight: 600;
    letter-spacing: .08em;
    text-transform: uppercase;
  }
  .home__hero h1 {
    font-size: 1.9rem !important;
    font-weight: 800;
    margin-bottom: 6px;
  }
  .home__hero p {
    margin: 0;
  }
  .home__hero-logo {
    position: relative;
    z-index: 1;
    flex-shrink: 0;
    width: 104px;
    height: 104px;
    border-radius: 50%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    box-shadow: 0 0 0 8px rgba(255, 255, 255, .2);
  }
  .home__hero-logo img {
    width: 92px;
  }
  .home__section {
    margin-top: 30px;
    animation: rise .45s ease-out .05s both;
  }
  .home__section h2 {
    font-size: .8rem !important;
    font-weight: 700;
    letter-spacing: .08em;
    text-transform: uppercase;
    color: var(--muted);
    margin-bottom: 12px;
  }
  .home__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(260px, 100%), 1fr));
    gap: 14px;
  }
  .home__card {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 18px 18px;
    background: white;
    border: 1px solid var(--line);
    border-radius: 14px;
    box-shadow: var(--shadow-sm);
    text-decoration: none;
    transition: transform .15s ease, box-shadow .15s ease, border-color .15s ease;
  }
  .home__card:hover {
    transform: translateY(-2px);
    border-color: #f0d38a;
    box-shadow: var(--shadow-md);
  }
  .home__icon {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.45rem;
    color: var(--jersey-yellow-dark);
    background: var(--jersey-yellow-soft);
  }
  .home__label {
    flex: 1;
    font-weight: 600;
    font-size: .98rem;
    color: var(--ink);
  }
  .home__arrow {
    color: #c3c7d0;
    font-size: 1.2rem;
    transition: transform .15s ease, color .15s ease;
  }
  .home__card:hover .home__arrow {
    color: var(--jersey-yellow-dark);
    transform: translateX(3px);
  }
  @keyframes rise {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @media (max-width: 768px) {
    .home__hero {
      padding: 24px;
    }
    .home__hero-logo {
      display: none;
    }
  }
</style>
